import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { getCategoryTranslations } from 'page/StartScreen/combine/utils'
import { store } from 'store/store'
import { Category } from 'type/rec'

type Props = {
  category: Category
}

export const CategoryCheckbox = observer(({ category }: Props) => {
  const item = store.item!
  const selected = item.rec.category.selected(category)

  const onClick = useLatestCallback(() => {
    item.rec.category.toggle(category)
  })

  return <Link action={onClick}>
    <Space minHeight={48} opposite>
      <Typo size={15} upper>
        {getCategoryTranslations(category.name)}
      </Typo>
      {selected && <Icon size={20} name="check" />}
    </Space>
  </Link>
})
